<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('user_detail.general')}}</h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.user_type')">
                  <b-form-select
                      v-model="form.user_type"
                      :options="user_types"
                      class="form-control form-control-solid"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.firstname')">
                  <b-form-input
                      v-model="form.firstname"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.firstname')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.lastname')">
                  <b-form-input
                      v-model="form.lastname"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.lastname')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.tc_no')">
                  <b-form-input
                      v-model="form.tc_no"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.tc_no')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.birth_date')">
                  <b-form-input
                      v-model="form.birth_date"
                      type="date"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.birth_date')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.birth_location')">
                  <b-form-select
                      v-model="form.birth_location"
                      :options="birth_locations"
                      class="form-control form-control-solid"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.gender')">
                  <b-form-select
                      v-model="form.gender"
                      :options="genders"
                      class="form-control form-control-solid"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.location')">
                  <b-form-select
                      v-model="form.location"
                      :options="locations"
                      class="form-control form-control-solid"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.ip_address')">
                  <b-form-input
                      v-model="form.ip_address"
                      type="date"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.ip_address')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.register_date')">
                  <b-form-input
                      v-model="form.register_date"
                      type="date"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.register_date')"
                      disabled
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.iban')">
                  <b-form-input
                      v-model="form.iban"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.iban')"
                      disabled
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.iban2')">
                  <b-form-input
                      v-model="form.iban2"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.iban2')"
                      disabled
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <b-form-group :label="$t('user_detail.address')">
                  <b-form-textarea class="form-control form-control-solid" id="textarea-rows" :placeholder="$t('user_detail.address')" rows="3" v-model="form.address"></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="separator separator-dashed mb-6"></div>
            <div class="row">
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.ses2')">
                  <b-form-input
                      v-model="form.ses2"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.ses2')"
                      disabled
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.m_level')">
                  <b-form-input
                      v-model="form.m_level"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.m_level')"
                      disabled
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.stdes')">
                  <b-form-input
                      v-model="form.stdEs"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.stdes')"
                      disabled
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.altes')">
                  <b-form-input
                      v-model="form.altES"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.altes')"
                      disabled
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="separator separator-dashed mb-6"></div>
            <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('user_detail.mail_gsm') }}</h3>
            <div class="row">
              <div class="col-md-4">
                <b-form-group :label="$t('general.email')">
                  <b-form-input
                      v-model="form.email"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('general.email')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.alternative_email')">
                  <b-form-input
                      v-model="form.alternative_email"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.alternative_email')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.email_preference')">
                  <b-form-select
                      v-model="form.email_preference"
                      :options="email_preferences"
                      class="form-control form-control-solid"
                      disabled
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group :label="$t('user_detail.email_status')">
                  <b-form-select
                      v-model="form.email_status"
                      :options="email_status"
                      class="form-control form-control-solid"
                      disabled
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group :label="$t('user_detail.email_perm_type')">
                  <b-form-select
                      v-model="form.email_perm_type"
                      :options="email_perm_type"
                      class="form-control form-control-solid"
                  ></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="separator separator-dashed mb-6"></div>
            <div class="row">
              <div class="col-md-3">
                  <b-form-group :label="$t('user_detail.gsm_status')">
                    <b-form-select
                        v-model="form.gsm_status"
                        :options="gsm_status"
                        class="form-control form-control-solid"
                        disabled
                    ></b-form-select>
                  </b-form-group>
                </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.gsm_no')">
                  <b-form-input
                      v-model="form.gsm_no"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.gsm_no')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.gsm_perm_type')">
                  <b-form-select
                      v-model="form.gsm_perm_type"
                      :options="gsm_perm_type"
                      class="form-control form-control-solid"
                      disabled
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.home_phone')">
                  <b-form-input
                      v-model="form.home_phone"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.home_phone')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-button-group>
                  <b-button size="sm"><i class="far fa-times-circle"></i> {{$t('user_detail.gsm_cancel')}}</b-button>
                  <b-button size="sm"><i class="fas fa-save"></i> {{$t('user_detail.update_gsm')}}</b-button>
                </b-button-group>
              </div>
              <div class="col-md-3">
                <b-button size="sm"><i class="fas fa-search"></i> {{$t('user_detail.code_control')}}</b-button>
              </div>
              <div class="col-md-3">
                <b-form-input
                    size="sm"
                    type="text"
                    :placeholder="$t('user_detail.code_area')"
                    required
                ></b-form-input>
              </div>
            </div>
            <div class="separator separator-dashed mb-6 mt-5"></div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group :label="$t('user_detail.verification_codes_sent')">
                  <b-form-textarea
                      disabled
                      class="form-control form-control-solid"
                      id="textarea-rows"
                      :placeholder="$t('user_detail.verification_codes_sent')"
                      rows="5">
                  </b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="separator separator-dashed mb-6 mt-5"></div>
            <div class="row">
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.sent_sms_count')">
                  <b-form-input
                      v-model="form.sent_sms_count"
                      disabled
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.sent_sms_count')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.sent_email_count')">
                  <b-form-input
                      v-model="form.sent_email_count"
                      disabled
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.sent_email_count')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.member_source')">
                  <b-form-input
                      v-model="form.member_source"
                      disabled
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.member_source')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.sub_user_count')">
                  <b-form-input
                      v-model="form.sub_user_count"
                      disabled
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.sub_user_count')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.active_sub_user_count')">
                  <b-form-input
                      v-model="form.active_sub_user_count"
                      disabled
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.active_sub_user_count')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.bounce_invite_count')">
                  <b-form-input
                      v-model="form.bounce_invite_count"
                      disabled
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.bounce_invite_count')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.invite_authorization_code')">
                  <b-button disabled size="sm"><i class="fas fa-user-lock"></i> {{$t('user_detail.open_invite_authority')}}</b-button>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group :label="$t('user_detail.facebook_id')">
                  <b-form-input
                      v-model="form.facebook_id"
                      disabled
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.facebook_id')"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <div class="separator separator-dashed mb-6"></div>
            <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('user_detail.parent_information') }}</h3>
            <div class="row">
              <div class="col-md-4">
                <b-form-group :label="$t('users.member_id')">
                  <b-form-input
                      v-model="form.member_id"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('users.member_id')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('user_detail.ref_no')">
                  <b-form-input
                      v-model="form.ref_no"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.ref_no')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-4">
                <b-form-group :label="$t('general.email')">
                  <b-form-input
                      v-model="form.parent_email"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('general.email')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group :label="$t('user_detail.firstname')">
                  <b-form-input
                      v-model="form.parent_firstname"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.firstname')"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-6">
                <b-form-group :label="$t('user_detail.lastname')">
                  <b-form-input
                      v-model="form.parent_lastname"
                      type="text"
                      class="form-control form-control-solid"
                      :placeholder="$t('user_detail.lastname')"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
             <div class="row">
              <div class="col-md-6">
                <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('user_detail.answered_questions') }}</h3>
                <div class="separator separator-dashed my-6"></div>
                <b-table
                    :bordered="table.bordered"
                    :outlined="table.outlined"
                    :small="table.small"
                    :hover="table.hover"
                    :fixed="table.fixed"
                    :items="table.answered"
                    :head-variant="table.headvariant"
                ></b-table>
              </div>
              <div class="col-md-6">
                <h3 class="font-size-lg text-dark font-weight-bold mb-6">{{ $t('user_detail.unanswered_questions') }}</h3>
                <div class="separator separator-dashed my-6"></div>
                <b-table
                    :bordered="table.bordered"
                    :outlined="table.outlined"
                    :small="table.small"
                    :hover="table.hover"
                    :fixed="table.fixed"
                    :items="table.unanswered"
                    :head-variant="table.headvariant"
                ></b-table>
              </div>
            </div>


          </div>
          <!--end::Body-->
          <div class="card-footer">
            <b-button-group class="fa-pull-right">
              <b-button @click="ConfirmSave"><i class="fa fa-save"></i> {{ $t('general.save') }}</b-button>
              <b-dropdown right>
                <b-dropdown-item><i class="mr-5 fas fa-sync"></i> {{ $t('user_detail.refresh_information') }}</b-dropdown-item>
                <b-dropdown-item><i class="mr-5 fa fa-image"></i> {{ $t('user_detail.show_image') }}</b-dropdown-item>
                <b-dropdown-item><i class="mr-5 fas fa-question"></i> {{ $t('user_detail.show_unanswered_questions') }}</b-dropdown-item>
                <b-dropdown-item><i class="mr-5 fas fa-envelope-open-text"></i> {{ $t('user_detail.email_update') }}</b-dropdown-item>
                <b-dropdown-item><i class="mr-5 fas fa-paper-plane"></i> {{ $t('user_detail.send_an_activation_email') }}</b-dropdown-item>
                <b-dropdown-item><i class="mr-5 fa fas fa-mobile-alt"></i> {{ $t('user_detail.send_password_sms') }}</b-dropdown-item>
              </b-dropdown>
            </b-button-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Swal from "sweetalert2";

export default {
  name: "UserInformation",
  components: { },
  data() {
    return {
      form : {
        user_type : 'Aktif Üye',
        tc_no : '15890259423',
        birth_date : '1985-12-15',
        firstname : 'Serdar',
        lastname : 'Aşar',
        gender : 'Erkek',
        birth_location : 'Gaziantep',
        location : 'Gaziantep',
        ip_address : '49.196.145.124',
        iban : '',
        iban2 : '',
        register_date : '2018-07-17',
        ses2 : 'D',
        m_level : 'Nap 1',
        stdEs : 'CNF',
        altES : '',
        email : 'serdar_1369@hotmail.com',
        alternative_email : '',
        email_preference : 'STD',
        email_status : 'CNF',
        email_perm_type: 'GRN',
        gsm_status : 'CNF',
        gsm_no : '5367334574',
        home_phone : '5367334574',
        gsm_perm_type: 'GRN',
        sent_sms_count: '0',
        sent_email_count: '0',
        member_source: 'SLF',
        sub_user_count:'0',
        active_sub_user_count:'0',
        bounce_invite_count:'0',
        facebook_id:'202218914494594',
        address : 'Kolejtepe Mh. Mehmet dai Sk. ...',
        member_id : '',
        ref_no : '',
        parent_email : '',
        parent_firstname : '',
        parent_lastname : ''
      },
      user_types: [{ text: this.$t('general.select'), value: null }, 'Yeni Üye','Aktif Üye','Pasif Üye','Fraud Yapan Üye','Fraud Üyelik','Çöp',"ST'de Silinmeyi İsteyen","Napolyon'da Silinmeyi İsteyen",],
      genders: [{ text: this.$t('general.select'), value: null }, 'Erkek', 'Kadın'],
      birth_locations : [{ text: this.$t('general.select'), value: null }, 'İstanbul', 'Ankara', 'Gaziantep','Yalova', 'İzmir', 'Diyarbakır', 'Samsun'],
      locations : [{ text: this.$t('general.select'), value: null }, 'İstanbul', 'Ankara', 'Gaziantep','Yalova', 'İzmir', 'Diyarbakır', 'Samsun'],
      email_preferences: [{ text: this.$t('general.select'), value: null }, 'STD', ''],
      email_status: [{ text: this.$t('general.select'), value: null }, 'CNF'],
      email_perm_type: [{ text: this.$t('general.select'), value: null }, 'GRN'],
      gsm_status: [{ text: this.$t('general.select'), value: null }, 'CNF'],
      gsm_perm_type: [{ text: this.$t('general.select'), value: null }, 'GRN'],
      table : {
        bordered : true,
        outlined : true,
        small : true,
        fixed : true,
        hover : true,
        headvariant : 'light',
        answered : [
          { 'QuestionID': '13', 'Question Text': "Cinsiyetiniz", 'Answer ID': "1", 'Answer Text' : "Erkek" },
          { 'QuestionID': '14', 'Question Text': "Medeni Durumunuz", 'Answer ID': "2", 'Answer Text' : "Bekar" },
          { 'QuestionID': '15', 'Question Text': "Çocuğunuz var mı ?", 'Answer ID': "8", 'Answer Text' : "Yok" },
          { 'QuestionID': '13', 'Question Text': "Cinsiyetiniz", 'Answer ID': "1", 'Answer Text' : "Erkek" },
          { 'QuestionID': '14', 'Question Text': "Medeni Durumunuz", 'Answer ID': "2", 'Answer Text' : "Bekar" },
          { 'QuestionID': '15', 'Question Text': "Çocuğunuz var mı ?", 'Answer ID': "8", 'Answer Text' : "Yok" },
        ],
        unanswered : [
          { 'QuestionID': '..', '..': "..", '': "" },
          { 'QuestionID': '..', '..': "..", '': "" },
          { 'QuestionID': '..', '..': "..", '': "" },
        ],
      }
    };
  },
  methods : {
    ConfirmSave(){
      Swal.fire({
        title: "Dikkat!",
        text: "Güncellenecek bilgiler arasında tipi de yer alıyor. Onaylıyor musunuz?",
        icon: "question",
        confirmButtonClass: "btn btn-secondary",
        confirmButtonText : "Evet",
        showCancelButton: true,
        cancelButtonClass: "btn btn-warning",
        cancelButtonText: "Hayır"
      });
    }
  }
};
</script>
